// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__2OSba","box":"WorkspacesBox_box__XD3V1","node":"WorkspacesBox_node__3Q3tn"};